import React, { useEffect, useState } from 'react'
import RishTestimonial from '../Rishikesh/RishTestimonial'
import RishikeshHead from '../Rishikesh/RishikeshHead';
// import JimcorbettBanner from './JimcorbettBanner';
import Accommodation from './Accommodation';
import JimCorbetIntro from './JimCorbetIntro';
import Farming from './Farming';
import RishikeshNearby from '../Rishikesh/RishikeshNearby';
import JimcorbettWeddEvents from './JimcorbettWeddEvents';
import OfferPopup from '../../component/OfferPopup';
import RishikeshBanner from '../Rishikesh/RishikeshBanner';

export default function Jimcorbett() {
const [showPopup, setShowPopup] = useState(false);

useEffect(() => {
  setShowPopup(true);
}, []);

const handleClose = () => {
  setShowPopup(false);
};


  const bannerData = {
    images: [
      { img: "/image/jimcorbet-banner-1.webp" },
      { img: "/image/jimcorbet-banner-2.webp" },
      { img: "/image/jimcorbet-banner-3.webp" },
      { img: "/image/jimcorbet-banner-2.webp" },
    ],
    buttonLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y",
  };


  const quoteHead = {
    title: "Resort De Coração Jim Corbett",
    desc: "Located in the quiet landscapes of Jim Corbett, our resort is more than just a place to stay; it’s a gateway to the wild. Every corner of De Coração reflects the raw beauty of the forest, providing a space where you can finally trade the city’s noise for the sounds of the jungle. Slow down, breathe in the fresh forest air, and find peace in nature’s rhythm.",
  };

  const nearbyData = [
    {
      img: "/image/jimcorbett-nearby-01.webp",
      title: "Dhikala Zone",
       distance: "2 hours 20 Mins",
       description: "The most iconic safari zone in Jim Corbett, known for vast grasslands, rich wildlife, and unforgettable jungle experiences.",
    },
    {
      img: "/image/jimcorbett-nearby-2.webp",
      title: "Garjiya Devi Temple",
       distance: "14 km",
         description: "A famous riverside temple beautifully set on a large rock, attracting visitors for its peaceful spiritual atmosphere.",
    },
    {
      img: "/image/jimcorbett-nearby-3.webp",
      title: "Corbett Waterfall",
       distance: "22 km",
         description: "A serene natural waterfall surrounded by dense forest, perfect for relaxation, photography, and quiet nature walks.",
    },
    {
      img: "/image/jimcorbett-nearby-4.webp",
      title: "Kalagarh Dam",
       distance: "1 hours 44 Mins",
         description: "A scenic dam offering calm water views, lush surroundings, and a peaceful escape close to the national park.",
    },
  ];


const offerPopupData = {
    leftImage: "/image/offer-left-image-2.webp",
    mobileImage: "/image/offer-left-mobile-image-2.webp",

    label: "brand website",
    title: "exclusive",
    highlight: "offer",

    description:
        "Enjoy exclusive benefits when you book directly through our Brand Website.",

    showPoints: true,

    benefits: [
        {
            icon: "/image/offerpopup-icon-1.webp",
            text1: "15% OFF",
            text2: "on Food & Beverages",
        },
        {
            icon: "/image/offerpopup-icon-8.webp",
            text1: "30% OFF",
            text2: "on Spa",
            // text2Class: "price-highlight",
        },
        {
            icon: "/image/offerpopup-icon-3.webp",
            text1: "20% OFF",
            text2: "on Laundry",
        },
        {
            icon: "/image/offerpopup-icon-4.webp",
            text1: "Luxury to Premium Cottage  -Complimentary Upgrade",
           
        },
        {
            icon: "/image/offerpopup-icon-5.webp",
            text1: "Early Check-in & Late Check-out — Subject to availability",
           
        },
        {
            icon: "/image/offerpopup-icon-6.webp",
            text1: "Complimentary Hi-Tea - Bookings on MAP & AP Meal Plans",
          
        },
         {
            icon: "/image/offerpopup-icon-5.webp",
            text1: "One-Time Complimentary Adventure Activities:<br/>Zipline (1 Ride), Wall Climbing (1 Attempt), Archery (5 Shots), Gun Shooting (5 Shots), Trampoline",
           
        },
       
      
    ],
};

const testimonialData = [
    {
        text: "De Coração made our Corbett trip feel completely different. The peaceful surroundings, beautiful cottage and warm hospitality gave us the perfect break from city life.",
        image: "/image/Rohan-Mehta.webp",
        name: "Rohan Mehta",
        designation: "Delhi",
    },
    {
        text: "From the forest trails to the delicious Kumaoni food, everything felt thoughtfully planned. The resort gave us both adventure and a wonderful sense of calm.",
        image: "/image/Priya-Sharma.webp",
        name: "Priya Sharma",
        designation: "Mumbai",
    },
    {
        text: "Our cottage was spacious, comfortable and beautifully connected to the natural surroundings. The entire experience felt peaceful, private and genuinely refreshing.",
        image: "/image/Karan-Bhatia.webp",
        name: "Karan Bhatia",
        designation: "Chandigarh",
    },
    {
        text: "What stood out most was the hospitality. The team was warm, attentive and always ready to help, making our family holiday incredibly comfortable.",
        image: "/image/Neha-Kapoor.webp",
        name: "Neha Kapoor",
        designation: "Noida",
    },
    {
        text: "There is something special about waking up surrounded by the forest. De Coração gave us the perfect balance of wildlife, relaxation, good food and comfort.",
        image: "/image/Aarav-Malhotra.webp",
        name: "Aarav Malhotra",
        designation: "Jaipur",
    },
];

  return (
    <>
      {/* <JimcorbettBanner /> */}
      <RishikeshBanner bannerImages={bannerData.images} buttonLink={bannerData.buttonLink} />
      <RishikeshHead quoteHead={quoteHead} />
      <Accommodation />
      <JimCorbetIntro />
      <Farming />
      <RishTestimonial testimonialData={testimonialData} showHeading={false} />
      <JimcorbettWeddEvents />
      <RishikeshNearby nearbyData={nearbyData} />

      <OfferPopup show={showPopup} onHide={handleClose} data={offerPopupData}/>
    </>
  )
}
